const domain: string = 'YF_POPIN'

export const SAVE_YF_MANAGER_IMAGE: string = `${domain}/SAVE_YF_MANAGER_IMAGE`
export const SAVE_YF_MANAGER_DATA: string = `${domain}/SAVE_YF_MANAGER_DATA`
